var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackGroundOfSectionTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1829,
    viewBox: "0 0 1920 1829",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.02
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_599",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 1829
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1829,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.02 26L194.077 115.057L105.02 204.114L66.8455 165.939L79.5705 153.214L105.02 178.664L168.627 115.057L92.2955 38.725L105.02 26Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 51.4319L92.2954 64.1569L41.4136 115.057L66.8454 140.507L54.1386 153.214L15.9636 115.057L79.5704 51.4319Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.312 26L395.368 115.057L306.312 204.114L268.155 165.939L280.862 153.214L306.312 178.664L369.918 115.057L293.587 38.725L306.312 26Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.862 51.4319L293.587 64.1569L242.705 115.057L268.155 140.507L255.43 153.214L217.255 115.057L280.862 51.4319Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.603 26L596.66 115.057L507.603 204.114L469.446 165.939L482.171 153.214L507.603 178.664L571.228 115.057L494.878 38.725L507.603 26Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.171 51.4319L494.896 64.1569L443.996 115.057L469.446 140.507L456.721 153.214L418.546 115.057L482.171 51.4319Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.913 26L797.969 115.057L708.913 204.114L670.738 165.939L683.463 153.214L708.894 178.664L772.519 115.057L696.188 38.725L708.913 26Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.463 51.4319L696.188 64.1569L645.288 115.057L670.738 140.507L658.013 153.214L619.856 115.057L683.463 51.4319Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.204 26L999.261 115.057L910.204 204.114L872.029 165.939L884.754 153.214L910.204 178.664L973.811 115.057L897.479 38.725L910.204 26Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.754 51.4319L897.479 64.1569L846.579 115.057L872.029 140.507L859.304 153.214L821.147 115.057L884.754 51.4319Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 26L1200.55 115.057L1111.5 204.114L1073.32 165.939L1086.05 153.214L1111.5 178.664L1175.1 115.057L1098.77 38.725L1111.5 26Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 51.4319L1098.77 64.1569L1047.89 115.057L1073.32 140.507L1060.61 153.214L1022.44 115.057L1086.05 51.4319Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 26L1401.84 115.057L1312.79 204.114L1274.63 165.939L1287.34 153.214L1312.79 178.664L1376.39 115.057L1300.06 38.725L1312.79 26Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 51.4319L1300.06 64.1569L1249.18 115.057L1274.63 140.507L1261.9 153.214L1223.73 115.057L1287.34 51.4319Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 26L1603.13 115.057L1514.08 204.114L1475.92 165.939L1488.65 153.214L1514.08 178.664L1577.7 115.057L1501.35 38.725L1514.08 26Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 51.4319L1501.37 64.1569L1450.47 115.057L1475.92 140.507L1463.2 153.214L1425.02 115.057L1488.65 51.4319Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 26L1804.44 115.057L1715.39 204.114L1677.21 165.939L1689.94 153.214L1715.39 178.664L1778.99 115.057L1702.66 38.725L1715.39 26Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 51.4319L1702.66 64.1569L1651.76 115.057L1677.21 140.507L1664.49 153.214L1626.33 115.057L1689.94 51.4319Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 26L2005.74 115.057L1916.68 204.114L1878.5 165.939L1891.23 153.214L1916.68 178.664L1980.29 115.057L1903.95 38.725L1916.68 26Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 51.4319L1903.95 64.1569L1853.05 115.057L1878.5 140.507L1865.78 153.214L1827.62 115.057L1891.23 51.4319Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 133.181L92.1135 222.238L3.05672 311.295L-35.1001 273.12L-22.3751 260.395L3.05672 285.845L66.6817 222.238L-9.6501 145.906L3.05672 133.181Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.366 133.181L293.423 222.238L204.366 311.295L166.191 273.12L178.916 260.395L204.366 285.845L267.973 222.238L191.641 145.906L204.366 133.181Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.916 158.631L191.641 171.338L140.741 222.238L166.191 247.688L153.466 260.395L115.31 222.238L178.916 158.631Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.658 133.181L494.714 222.238L405.658 311.295L367.483 273.12L380.208 260.395L405.658 285.845L469.264 222.238L392.933 145.906L405.658 133.181Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.208 158.631L392.933 171.338L342.051 222.238L367.483 247.688L354.758 260.395L316.601 222.238L380.208 158.631Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.949 133.181L696.006 222.238L606.949 311.295L568.774 273.12L581.499 260.395L606.949 285.845L670.556 222.238L594.224 145.906L606.949 133.181Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.499 158.631L594.224 171.338L543.342 222.238L568.774 247.688L556.067 260.395L517.892 222.238L581.499 158.631Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.241 133.181L897.297 222.238L808.241 311.295L770.084 273.12L782.791 260.395L808.241 285.845L871.847 222.238L795.516 145.906L808.241 133.181Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.809 158.631L795.515 171.338L744.634 222.238L770.084 247.688L757.359 260.395L719.184 222.238L782.809 158.631Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 133.181L1098.61 222.238L1009.53 311.295L971.375 273.12L984.1 260.395L1009.53 285.845L1073.16 222.238L996.825 145.906L1009.53 133.181Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.1 158.631L996.825 171.338L945.925 222.238L971.375 247.688L958.65 260.395L920.475 222.238L984.1 158.631Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 133.181L1299.9 222.238L1210.84 311.295L1172.67 273.12L1185.39 260.395L1210.84 285.845L1274.45 222.238L1198.12 145.906L1210.84 133.181Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 158.631L1198.12 171.338L1147.22 222.238L1172.67 247.688L1159.94 260.395L1121.78 222.238L1185.39 158.631Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 133.181L1501.19 222.238L1412.13 311.295L1373.96 273.12L1386.68 260.395L1412.13 285.845L1475.74 222.238L1399.41 145.906L1412.13 133.181Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 158.631L1399.41 171.338L1348.53 222.238L1373.96 247.688L1361.23 260.395L1323.08 222.238L1386.68 158.631Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 133.181L1702.48 222.238L1613.42 311.295L1575.25 273.12L1587.97 260.395L1613.42 285.845L1677.03 222.238L1600.7 145.906L1613.42 133.181Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 158.631L1600.7 171.338L1549.82 222.238L1575.25 247.688L1562.54 260.395L1524.37 222.238L1587.97 158.631Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 133.181L1903.77 222.238L1814.71 311.295L1776.56 273.12L1789.26 260.395L1814.71 285.845L1878.34 222.238L1801.99 145.906L1814.71 133.181Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 158.631L1801.99 171.338L1751.11 222.238L1776.56 247.688L1763.83 260.395L1725.66 222.238L1789.28 158.631Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.02 239.053L194.077 328.11L105.02 417.166L66.8455 379.01L79.5705 366.285L105.02 391.716L168.627 328.11L92.2955 251.778L105.02 239.053Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 264.503L92.2954 277.228L41.4136 328.11L66.8454 353.56L54.1386 366.285L15.9636 328.11L79.5704 264.503Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.312 239.053L395.368 328.11L306.312 417.166L268.155 379.01L280.862 366.285L306.312 391.716L369.918 328.11L293.587 251.778L306.312 239.053Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.862 264.503L293.587 277.228L242.705 328.11L268.155 353.56L255.43 366.285L217.255 328.11L280.862 264.503Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.603 239.053L596.66 328.11L507.603 417.166L469.446 379.01L482.171 366.285L507.603 391.716L571.228 328.11L494.878 251.778L507.603 239.053Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.171 264.503L494.896 277.228L443.996 328.11L469.446 353.56L456.721 366.285L418.546 328.11L482.171 264.503Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.913 239.053L797.969 328.11L708.913 417.166L670.738 379.01L683.463 366.285L708.894 391.716L772.519 328.11L696.188 251.778L708.913 239.053Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.463 264.503L696.188 277.228L645.288 328.11L670.738 353.56L658.013 366.285L619.856 328.11L683.463 264.503Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.204 239.053L999.261 328.11L910.204 417.166L872.029 379.01L884.754 366.285L910.204 391.716L973.811 328.11L897.479 251.778L910.204 239.053Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.754 264.503L897.479 277.228L846.579 328.11L872.029 353.56L859.304 366.285L821.147 328.11L884.754 264.503Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 239.053L1200.55 328.11L1111.5 417.166L1073.32 379.01L1086.05 366.285L1111.5 391.716L1175.1 328.11L1098.77 251.778L1111.5 239.053Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 264.503L1098.77 277.228L1047.89 328.11L1073.32 353.56L1060.61 366.285L1022.44 328.11L1086.05 264.503Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 239.053L1401.84 328.11L1312.79 417.166L1274.63 379.01L1287.34 366.285L1312.79 391.716L1376.39 328.11L1300.06 251.778L1312.79 239.053Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 264.503L1300.06 277.228L1249.18 328.11L1274.63 353.56L1261.9 366.285L1223.73 328.11L1287.34 264.503Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 239.053L1603.13 328.11L1514.08 417.166L1475.92 379.01L1488.65 366.285L1514.08 391.716L1577.7 328.11L1501.35 251.778L1514.08 239.053Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 264.503L1501.37 277.228L1450.47 328.11L1475.92 353.56L1463.2 366.285L1425.02 328.11L1488.65 264.503Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 239.053L1804.44 328.11L1715.39 417.166L1677.21 379.01L1689.94 366.285L1715.39 391.716L1778.99 328.11L1702.66 251.778L1715.39 239.053Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 264.503L1702.66 277.228L1651.76 328.11L1677.21 353.56L1664.49 366.285L1626.33 328.11L1689.94 264.503Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 239.053L2005.74 328.11L1916.68 417.166L1878.5 379.01L1891.23 366.285L1916.68 391.716L1980.29 328.11L1903.95 251.778L1916.68 239.053Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 264.503L1903.95 277.228L1853.05 328.11L1878.5 353.56L1865.78 366.285L1827.62 328.11L1891.23 264.503Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 346.234L92.1135 435.29L3.05672 524.347L-35.1001 486.19L-22.3751 473.465L3.05672 498.915L66.6817 435.29L-9.6501 358.959L3.05672 346.234Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.366 346.234L293.423 435.29L204.366 524.347L166.191 486.19L178.916 473.465L204.366 498.915L267.973 435.29L191.641 358.959L204.366 346.234Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.916 371.684L191.641 384.409L140.741 435.291L166.191 460.741L153.466 473.466L115.31 435.291L178.916 371.684Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.658 346.234L494.714 435.29L405.658 524.347L367.483 486.19L380.208 473.465L405.658 498.915L469.264 435.29L392.933 358.959L405.658 346.234Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.208 371.684L392.933 384.409L342.051 435.291L367.483 460.741L354.758 473.466L316.601 435.291L380.208 371.684Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.949 346.234L696.006 435.29L606.949 524.347L568.774 486.19L581.499 473.465L606.949 498.915L670.556 435.29L594.224 358.959L606.949 346.234Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.499 371.684L594.224 384.409L543.342 435.291L568.774 460.741L556.067 473.466L517.892 435.291L581.499 371.684Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.241 346.234L897.297 435.29L808.241 524.347L770.084 486.19L782.791 473.465L808.241 498.915L871.847 435.29L795.516 358.959L808.241 346.234Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.809 371.684L795.515 384.409L744.634 435.291L770.084 460.741L757.359 473.466L719.184 435.291L782.809 371.684Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 346.234L1098.61 435.29L1009.53 524.347L971.375 486.19L984.1 473.465L1009.53 498.915L1073.16 435.29L996.825 358.959L1009.53 346.234Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.1 371.684L996.825 384.409L945.925 435.291L971.375 460.741L958.65 473.466L920.475 435.291L984.1 371.684Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 346.234L1299.9 435.29L1210.84 524.347L1172.67 486.19L1185.39 473.465L1210.84 498.915L1274.45 435.29L1198.12 358.959L1210.84 346.234Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 371.684L1198.12 384.409L1147.22 435.291L1172.67 460.741L1159.94 473.466L1121.78 435.291L1185.39 371.684Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 346.234L1501.19 435.29L1412.13 524.347L1373.96 486.19L1386.68 473.465L1412.13 498.915L1475.74 435.29L1399.41 358.959L1412.13 346.234Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 371.684L1399.41 384.409L1348.53 435.291L1373.96 460.741L1361.23 473.466L1323.08 435.291L1386.68 371.684Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 346.234L1702.48 435.29L1613.42 524.347L1575.25 486.19L1587.97 473.465L1613.42 498.915L1677.03 435.29L1600.7 358.959L1613.42 346.234Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 371.684L1600.7 384.409L1549.82 435.291L1575.25 460.741L1562.54 473.466L1524.37 435.291L1587.97 371.684Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 346.234L1903.77 435.29L1814.71 524.347L1776.56 486.19L1789.26 473.465L1814.71 498.915L1878.34 435.29L1801.99 358.959L1814.71 346.234Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 371.684L1801.99 384.409L1751.11 435.291L1776.56 460.741L1763.83 473.466L1725.66 435.291L1789.28 371.684Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.02 452.106L194.077 541.163L105.02 630.219L66.8455 592.063L79.5705 579.338L105.02 604.788L168.627 541.163L92.2955 464.831L105.02 452.106Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 477.556L92.2954 490.281L41.4136 541.181L66.8454 566.612L54.1386 579.338L15.9636 541.162L79.5704 477.556Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.312 452.106L395.368 541.163L306.312 630.219L268.155 592.063L280.862 579.338L306.312 604.788L369.918 541.163L293.587 464.831L306.312 452.106Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.862 477.556L293.587 490.281L242.705 541.181L268.155 566.612L255.43 579.338L217.255 541.162L280.862 477.556Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.603 452.106L596.66 541.163L507.603 630.219L469.446 592.063L482.171 579.338L507.603 604.788L571.228 541.163L494.878 464.831L507.603 452.106Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.171 477.556L494.896 490.281L443.996 541.181L469.446 566.612L456.721 579.338L418.546 541.162L482.171 477.556Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.913 452.106L797.969 541.163L708.913 630.219L670.738 592.063L683.463 579.338L708.894 604.788L772.519 541.163L696.188 464.831L708.913 452.106Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.463 477.556L696.188 490.281L645.288 541.181L670.738 566.612L658.013 579.338L619.856 541.162L683.463 477.556Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.204 452.106L999.261 541.163L910.204 630.219L872.029 592.063L884.754 579.338L910.204 604.788L973.811 541.163L897.479 464.831L910.204 452.106Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.754 477.556L897.479 490.281L846.579 541.181L872.029 566.612L859.304 579.338L821.147 541.162L884.754 477.556Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 452.106L1200.55 541.163L1111.5 630.219L1073.32 592.063L1086.05 579.338L1111.5 604.788L1175.1 541.163L1098.77 464.831L1111.5 452.106Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 477.556L1098.77 490.281L1047.89 541.181L1073.32 566.612L1060.61 579.338L1022.44 541.162L1086.05 477.556Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 452.106L1401.84 541.163L1312.79 630.219L1274.63 592.063L1287.34 579.338L1312.79 604.788L1376.39 541.163L1300.06 464.831L1312.79 452.106Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 477.556L1300.06 490.281L1249.18 541.181L1274.63 566.612L1261.9 579.338L1223.73 541.162L1287.34 477.556Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 452.106L1603.13 541.163L1514.08 630.219L1475.92 592.063L1488.65 579.338L1514.08 604.788L1577.7 541.163L1501.35 464.831L1514.08 452.106Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 477.556L1501.37 490.281L1450.47 541.181L1475.92 566.612L1463.2 579.338L1425.02 541.162L1488.65 477.556Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 452.106L1804.44 541.163L1715.39 630.219L1677.21 592.063L1689.94 579.338L1715.39 604.788L1778.99 541.163L1702.66 464.831L1715.39 452.106Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 477.556L1702.66 490.281L1651.76 541.181L1677.21 566.612L1664.49 579.338L1626.33 541.162L1689.94 477.556Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 452.106L2005.74 541.163L1916.68 630.219L1878.5 592.063L1891.23 579.338L1916.68 604.788L1980.29 541.163L1903.95 464.831L1916.68 452.106Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 477.556L1903.95 490.281L1853.05 541.181L1878.5 566.612L1865.78 579.338L1827.62 541.162L1891.23 477.556Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 559.305L92.1135 648.361L3.05672 737.418L-35.1001 699.243L-22.3751 686.518L3.05672 711.968L66.6817 648.361L-9.6501 572.011L3.05672 559.305Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.366 559.305L293.423 648.361L204.366 737.418L166.191 699.243L178.916 686.518L204.366 711.968L267.973 648.361L191.641 572.011L204.366 559.305Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.916 584.736L191.641 597.461L140.741 648.361L166.191 673.793L153.466 686.518L115.31 648.361L178.916 584.736Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.658 559.305L494.714 648.361L405.658 737.418L367.483 699.243L380.208 686.518L405.658 711.968L469.264 648.361L392.933 572.011L405.658 559.305Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.208 584.736L392.933 597.461L342.051 648.361L367.483 673.793L354.758 686.518L316.601 648.361L380.208 584.736Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.949 559.305L696.006 648.361L606.949 737.418L568.774 699.243L581.499 686.518L606.949 711.968L670.556 648.361L594.224 572.011L606.949 559.305Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.499 584.736L594.224 597.461L543.342 648.361L568.774 673.793L556.067 686.518L517.892 648.361L581.499 584.736Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.241 559.305L897.297 648.361L808.241 737.418L770.084 699.243L782.791 686.518L808.241 711.968L871.847 648.361L795.516 572.011L808.241 559.305Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.809 584.736L795.515 597.461L744.634 648.361L770.084 673.793L757.359 686.518L719.184 648.361L782.809 584.736Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 559.305L1098.61 648.361L1009.53 737.418L971.375 699.243L984.1 686.518L1009.53 711.968L1073.16 648.361L996.825 572.011L1009.53 559.305Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.1 584.736L996.825 597.461L945.925 648.361L971.375 673.793L958.65 686.518L920.475 648.361L984.1 584.736Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 559.305L1299.9 648.361L1210.84 737.418L1172.67 699.243L1185.39 686.518L1210.84 711.968L1274.45 648.361L1198.12 572.011L1210.84 559.305Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 584.736L1198.12 597.461L1147.22 648.361L1172.67 673.793L1159.94 686.518L1121.78 648.361L1185.39 584.736Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 559.305L1501.19 648.361L1412.13 737.418L1373.96 699.243L1386.68 686.518L1412.13 711.968L1475.74 648.361L1399.41 572.011L1412.13 559.305Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 584.736L1399.41 597.461L1348.53 648.361L1373.96 673.793L1361.23 686.518L1323.08 648.361L1386.68 584.736Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 559.305L1702.48 648.361L1613.42 737.418L1575.25 699.243L1587.97 686.518L1613.42 711.968L1677.03 648.361L1600.7 572.011L1613.42 559.305Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 584.736L1600.7 597.461L1549.82 648.361L1575.25 673.793L1562.54 686.518L1524.37 648.361L1587.97 584.736Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 559.305L1903.77 648.361L1814.71 737.418L1776.56 699.243L1789.26 686.518L1814.71 711.968L1878.34 648.361L1801.99 572.011L1814.71 559.305Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 584.736L1801.99 597.461L1751.11 648.361L1776.56 673.793L1763.83 686.518L1725.66 648.361L1789.28 584.736Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.02 665.177L194.077 754.234L105.02 843.29L66.8455 805.115L79.5705 792.39L105.02 817.84L168.627 754.234L92.2955 677.902L105.02 665.177Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 690.609L92.2954 703.334L41.4136 754.234L66.8454 779.684L54.1386 792.39L15.9636 754.234L79.5704 690.609Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.312 665.177L395.368 754.234L306.312 843.29L268.155 805.115L280.862 792.39L306.312 817.84L369.918 754.234L293.587 677.902L306.312 665.177Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.862 690.609L293.587 703.334L242.705 754.234L268.155 779.684L255.43 792.39L217.255 754.234L280.862 690.609Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.603 665.177L596.66 754.234L507.603 843.29L469.446 805.115L482.171 792.39L507.603 817.84L571.228 754.234L494.878 677.902L507.603 665.177Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.171 690.609L494.896 703.334L443.996 754.234L469.446 779.684L456.721 792.39L418.546 754.234L482.171 690.609Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.913 665.177L797.969 754.234L708.913 843.29L670.738 805.115L683.463 792.39L708.894 817.84L772.519 754.234L696.188 677.902L708.913 665.177Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.463 690.609L696.188 703.334L645.288 754.234L670.738 779.684L658.013 792.39L619.856 754.234L683.463 690.609Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.204 665.177L999.261 754.234L910.204 843.29L872.029 805.115L884.754 792.39L910.204 817.84L973.811 754.234L897.479 677.902L910.204 665.177Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.754 690.609L897.479 703.334L846.579 754.234L872.029 779.684L859.304 792.39L821.147 754.234L884.754 690.609Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 665.177L1200.55 754.234L1111.5 843.29L1073.32 805.115L1086.05 792.39L1111.5 817.84L1175.1 754.234L1098.77 677.902L1111.5 665.177Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 690.609L1098.77 703.334L1047.89 754.234L1073.32 779.684L1060.61 792.39L1022.44 754.234L1086.05 690.609Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 665.177L1401.84 754.234L1312.79 843.29L1274.63 805.115L1287.34 792.39L1312.79 817.84L1376.39 754.234L1300.06 677.902L1312.79 665.177Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 690.609L1300.06 703.334L1249.18 754.234L1274.63 779.684L1261.9 792.39L1223.73 754.234L1287.34 690.609Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 665.177L1603.13 754.234L1514.08 843.29L1475.92 805.115L1488.65 792.39L1514.08 817.84L1577.7 754.234L1501.35 677.902L1514.08 665.177Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 690.609L1501.37 703.334L1450.47 754.234L1475.92 779.684L1463.2 792.39L1425.02 754.234L1488.65 690.609Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 665.177L1804.44 754.234L1715.39 843.29L1677.21 805.115L1689.94 792.39L1715.39 817.84L1778.99 754.234L1702.66 677.902L1715.39 665.177Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 690.609L1702.66 703.334L1651.76 754.234L1677.21 779.684L1664.49 792.39L1626.33 754.234L1689.94 690.609Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 665.177L2005.74 754.234L1916.68 843.29L1878.5 805.115L1891.23 792.39L1916.68 817.84L1980.29 754.234L1903.95 677.902L1916.68 665.177Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 690.609L1903.95 703.334L1853.05 754.234L1878.5 779.684L1865.78 792.39L1827.62 754.234L1891.23 690.609Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 772.358L92.1135 861.414L3.05672 950.471L-35.1001 912.296L-22.3751 899.589L3.05672 925.021L66.6817 861.414L-9.6501 785.083L3.05672 772.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.366 772.358L293.423 861.414L204.366 950.471L166.191 912.296L178.916 899.589L204.366 925.021L267.973 861.414L191.641 785.083L204.366 772.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.916 797.808L191.641 810.514L140.741 861.414L166.191 886.864L153.466 899.589L115.31 861.414L178.916 797.808Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.658 772.358L494.714 861.414L405.658 950.471L367.483 912.296L380.208 899.589L405.658 925.021L469.264 861.414L392.933 785.083L405.658 772.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.208 797.808L392.933 810.514L342.051 861.414L367.483 886.864L354.758 899.589L316.601 861.414L380.208 797.808Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.949 772.358L696.006 861.414L606.949 950.471L568.774 912.296L581.499 899.589L606.949 925.021L670.556 861.414L594.224 785.083L606.949 772.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.499 797.808L594.224 810.514L543.342 861.414L568.774 886.864L556.067 899.589L517.892 861.414L581.499 797.808Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.241 772.358L897.297 861.414L808.241 950.471L770.084 912.296L782.791 899.589L808.241 925.021L871.847 861.414L795.516 785.083L808.241 772.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.809 797.808L795.515 810.514L744.634 861.414L770.084 886.864L757.359 899.589L719.184 861.414L782.809 797.808Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 772.358L1098.61 861.414L1009.53 950.471L971.375 912.296L984.1 899.589L1009.53 925.021L1073.16 861.414L996.825 785.083L1009.53 772.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.1 797.808L996.825 810.514L945.925 861.414L971.375 886.864L958.65 899.589L920.475 861.414L984.1 797.808Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 772.358L1299.9 861.414L1210.84 950.471L1172.67 912.296L1185.39 899.589L1210.84 925.021L1274.45 861.414L1198.12 785.083L1210.84 772.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 797.808L1198.12 810.514L1147.22 861.414L1172.67 886.864L1159.94 899.589L1121.78 861.414L1185.39 797.808Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 772.358L1501.19 861.414L1412.13 950.471L1373.96 912.296L1386.68 899.589L1412.13 925.021L1475.74 861.414L1399.41 785.083L1412.13 772.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 797.808L1399.41 810.514L1348.53 861.414L1373.96 886.864L1361.23 899.589L1323.08 861.414L1386.68 797.808Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 772.358L1702.48 861.414L1613.42 950.471L1575.25 912.296L1587.97 899.589L1613.42 925.021L1677.03 861.414L1600.7 785.083L1613.42 772.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 797.808L1600.7 810.514L1549.82 861.414L1575.25 886.864L1562.54 899.589L1524.37 861.414L1587.97 797.808Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 772.358L1903.77 861.414L1814.71 950.471L1776.56 912.296L1789.26 899.589L1814.71 925.021L1878.34 861.414L1801.99 785.083L1814.71 772.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 797.808L1801.99 810.514L1751.11 861.414L1776.56 886.864L1763.83 899.589L1725.66 861.414L1789.28 797.808Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.02 878.23L194.077 967.286L105.02 1056.34L66.8455 1018.19L79.5705 1005.46L105.02 1030.89L168.627 967.286L92.2955 890.955L105.02 878.23Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 903.68L92.2954 916.405L41.4136 967.286L66.8454 992.736L54.1386 1005.46L15.9636 967.286L79.5704 903.68Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.312 878.23L395.368 967.286L306.312 1056.34L268.155 1018.19L280.862 1005.46L306.312 1030.89L369.918 967.286L293.587 890.955L306.312 878.23Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.862 903.68L293.587 916.405L242.705 967.286L268.155 992.736L255.43 1005.46L217.255 967.286L280.862 903.68Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.603 878.23L596.66 967.286L507.603 1056.34L469.446 1018.19L482.171 1005.46L507.603 1030.89L571.228 967.286L494.878 890.955L507.603 878.23Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.171 903.68L494.896 916.405L443.996 967.286L469.446 992.736L456.721 1005.46L418.546 967.286L482.171 903.68Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.913 878.23L797.969 967.286L708.913 1056.34L670.738 1018.19L683.463 1005.46L708.894 1030.89L772.519 967.286L696.188 890.955L708.913 878.23Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.463 903.68L696.188 916.405L645.288 967.286L670.738 992.736L658.013 1005.46L619.856 967.286L683.463 903.68Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.204 878.23L999.261 967.286L910.204 1056.34L872.029 1018.19L884.754 1005.46L910.204 1030.89L973.811 967.286L897.479 890.955L910.204 878.23Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.754 903.68L897.479 916.405L846.579 967.286L872.029 992.736L859.304 1005.46L821.147 967.286L884.754 903.68Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 878.23L1200.55 967.286L1111.5 1056.34L1073.32 1018.19L1086.05 1005.46L1111.5 1030.89L1175.1 967.286L1098.77 890.955L1111.5 878.23Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 903.68L1098.77 916.405L1047.89 967.286L1073.32 992.736L1060.61 1005.46L1022.44 967.286L1086.05 903.68Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 878.23L1401.84 967.286L1312.79 1056.34L1274.63 1018.19L1287.34 1005.46L1312.79 1030.89L1376.39 967.286L1300.06 890.955L1312.79 878.23Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 903.68L1300.06 916.405L1249.18 967.286L1274.63 992.736L1261.9 1005.46L1223.73 967.286L1287.34 903.68Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 878.23L1603.13 967.286L1514.08 1056.34L1475.92 1018.19L1488.65 1005.46L1514.08 1030.89L1577.7 967.286L1501.35 890.955L1514.08 878.23Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 903.68L1501.37 916.405L1450.47 967.286L1475.92 992.736L1463.2 1005.46L1425.02 967.286L1488.65 903.68Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 878.23L1804.44 967.286L1715.39 1056.34L1677.21 1018.19L1689.94 1005.46L1715.39 1030.89L1778.99 967.286L1702.66 890.955L1715.39 878.23Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 903.68L1702.66 916.405L1651.76 967.286L1677.21 992.736L1664.49 1005.46L1626.33 967.286L1689.94 903.68Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 878.23L2005.74 967.286L1916.68 1056.34L1878.5 1018.19L1891.23 1005.46L1916.68 1030.89L1980.29 967.286L1903.95 890.955L1916.68 878.23Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 903.68L1903.95 916.405L1853.05 967.286L1878.5 992.736L1865.78 1005.46L1827.62 967.286L1891.23 903.68Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 985.41L92.1135 1074.47L3.05672 1163.52L-35.1001 1125.37L-22.3751 1112.64L3.05672 1138.09L66.6817 1074.47L-9.6501 998.135L3.05672 985.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.366 985.41L293.423 1074.47L204.366 1163.52L166.191 1125.37L178.916 1112.64L204.366 1138.09L267.973 1074.47L191.641 998.135L204.366 985.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.916 1010.86L191.641 1023.59L140.741 1074.47L166.191 1099.92L153.466 1112.64L115.31 1074.47L178.916 1010.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.658 985.41L494.714 1074.47L405.658 1163.52L367.483 1125.37L380.208 1112.64L405.658 1138.09L469.264 1074.47L392.933 998.135L405.658 985.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.208 1010.86L392.933 1023.59L342.051 1074.47L367.483 1099.92L354.758 1112.64L316.601 1074.47L380.208 1010.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.949 985.41L696.006 1074.47L606.949 1163.52L568.774 1125.37L581.499 1112.64L606.949 1138.09L670.556 1074.47L594.224 998.135L606.949 985.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.499 1010.86L594.224 1023.59L543.342 1074.47L568.774 1099.92L556.067 1112.64L517.892 1074.47L581.499 1010.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.241 985.41L897.297 1074.47L808.241 1163.52L770.084 1125.37L782.791 1112.64L808.241 1138.09L871.847 1074.47L795.516 998.135L808.241 985.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.809 1010.86L795.515 1023.59L744.634 1074.47L770.084 1099.92L757.359 1112.64L719.184 1074.47L782.809 1010.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 985.41L1098.61 1074.47L1009.53 1163.52L971.375 1125.37L984.1 1112.64L1009.53 1138.09L1073.16 1074.47L996.825 998.135L1009.53 985.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.1 1010.86L996.825 1023.59L945.925 1074.47L971.375 1099.92L958.65 1112.64L920.475 1074.47L984.1 1010.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 985.41L1299.9 1074.47L1210.84 1163.52L1172.67 1125.37L1185.39 1112.64L1210.84 1138.09L1274.45 1074.47L1198.12 998.135L1210.84 985.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 1010.86L1198.12 1023.59L1147.22 1074.47L1172.67 1099.92L1159.94 1112.64L1121.78 1074.47L1185.39 1010.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 985.41L1501.19 1074.47L1412.13 1163.52L1373.96 1125.37L1386.68 1112.64L1412.13 1138.09L1475.74 1074.47L1399.41 998.135L1412.13 985.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 1010.86L1399.41 1023.59L1348.53 1074.47L1373.96 1099.92L1361.23 1112.64L1323.08 1074.47L1386.68 1010.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 985.41L1702.48 1074.47L1613.42 1163.52L1575.25 1125.37L1587.97 1112.64L1613.42 1138.09L1677.03 1074.47L1600.7 998.135L1613.42 985.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 1010.86L1600.7 1023.59L1549.82 1074.47L1575.25 1099.92L1562.54 1112.64L1524.37 1074.47L1587.97 1010.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 985.41L1903.77 1074.47L1814.71 1163.52L1776.56 1125.37L1789.26 1112.64L1814.71 1138.09L1878.34 1074.47L1801.99 998.135L1814.71 985.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 1010.86L1801.99 1023.59L1751.11 1074.47L1776.56 1099.92L1763.83 1112.64L1725.66 1074.47L1789.28 1010.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.02 1091.28L194.077 1180.34L105.02 1269.4L66.8455 1231.24L79.5705 1218.51L105.02 1243.96L168.627 1180.34L92.2955 1104.01L105.02 1091.28Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 1116.73L92.2954 1129.46L41.4136 1180.36L66.8454 1205.79L54.1386 1218.51L15.9636 1180.34L79.5704 1116.73Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.312 1091.28L395.368 1180.34L306.312 1269.4L268.155 1231.24L280.862 1218.51L306.312 1243.96L369.918 1180.34L293.587 1104.01L306.312 1091.28Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.862 1116.73L293.587 1129.46L242.705 1180.36L268.155 1205.79L255.43 1218.51L217.255 1180.34L280.862 1116.73Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.603 1091.28L596.66 1180.34L507.603 1269.4L469.446 1231.24L482.171 1218.51L507.603 1243.96L571.228 1180.34L494.878 1104.01L507.603 1091.28Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.171 1116.73L494.896 1129.46L443.996 1180.36L469.446 1205.79L456.721 1218.51L418.546 1180.34L482.171 1116.73Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.913 1091.28L797.969 1180.34L708.913 1269.4L670.738 1231.24L683.463 1218.51L708.894 1243.96L772.519 1180.34L696.188 1104.01L708.913 1091.28Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.463 1116.73L696.188 1129.46L645.288 1180.36L670.738 1205.79L658.013 1218.51L619.856 1180.34L683.463 1116.73Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.204 1091.28L999.261 1180.34L910.204 1269.4L872.029 1231.24L884.754 1218.51L910.204 1243.96L973.811 1180.34L897.479 1104.01L910.204 1091.28Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.754 1116.73L897.479 1129.46L846.579 1180.36L872.029 1205.79L859.304 1218.51L821.147 1180.34L884.754 1116.73Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 1091.28L1200.55 1180.34L1111.5 1269.4L1073.32 1231.24L1086.05 1218.51L1111.5 1243.96L1175.1 1180.34L1098.77 1104.01L1111.5 1091.28Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 1116.73L1098.77 1129.46L1047.89 1180.36L1073.32 1205.79L1060.61 1218.51L1022.44 1180.34L1086.05 1116.73Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 1091.28L1401.84 1180.34L1312.79 1269.4L1274.63 1231.24L1287.34 1218.51L1312.79 1243.96L1376.39 1180.34L1300.06 1104.01L1312.79 1091.28Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 1116.73L1300.06 1129.46L1249.18 1180.36L1274.63 1205.79L1261.9 1218.51L1223.73 1180.34L1287.34 1116.73Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 1091.28L1603.13 1180.34L1514.08 1269.4L1475.92 1231.24L1488.65 1218.51L1514.08 1243.96L1577.7 1180.34L1501.35 1104.01L1514.08 1091.28Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 1116.73L1501.37 1129.46L1450.47 1180.36L1475.92 1205.79L1463.2 1218.51L1425.02 1180.34L1488.65 1116.73Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 1091.28L1804.44 1180.34L1715.39 1269.4L1677.21 1231.24L1689.94 1218.51L1715.39 1243.96L1778.99 1180.34L1702.66 1104.01L1715.39 1091.28Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 1116.73L1702.66 1129.46L1651.76 1180.36L1677.21 1205.79L1664.49 1218.51L1626.33 1180.34L1689.94 1116.73Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 1091.28L2005.74 1180.34L1916.68 1269.4L1878.5 1231.24L1891.23 1218.51L1916.68 1243.96L1980.29 1180.34L1903.95 1104.01L1916.68 1091.28Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 1116.73L1903.95 1129.46L1853.05 1180.36L1878.5 1205.79L1865.78 1218.51L1827.62 1180.34L1891.23 1116.73Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 1198.48L92.1135 1287.54L3.05672 1376.6L-35.1001 1338.42L-22.3751 1325.7L3.05672 1351.15L66.6817 1287.54L-9.6501 1211.19L3.05672 1198.48Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.366 1198.48L293.423 1287.54L204.366 1376.6L166.191 1338.42L178.916 1325.7L204.366 1351.15L267.973 1287.54L191.641 1211.19L204.366 1198.48Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.916 1223.91L191.641 1236.64L140.741 1287.54L166.191 1312.97L153.466 1325.7L115.31 1287.54L178.916 1223.91Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.658 1198.48L494.714 1287.54L405.658 1376.6L367.483 1338.42L380.208 1325.7L405.658 1351.15L469.264 1287.54L392.933 1211.19L405.658 1198.48Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.208 1223.91L392.933 1236.64L342.051 1287.54L367.483 1312.97L354.758 1325.7L316.601 1287.54L380.208 1223.91Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.949 1198.48L696.006 1287.54L606.949 1376.6L568.774 1338.42L581.499 1325.7L606.949 1351.15L670.556 1287.54L594.224 1211.19L606.949 1198.48Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.499 1223.91L594.224 1236.64L543.342 1287.54L568.774 1312.97L556.067 1325.7L517.892 1287.54L581.499 1223.91Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.241 1198.48L897.297 1287.54L808.241 1376.6L770.084 1338.42L782.791 1325.7L808.241 1351.15L871.847 1287.54L795.516 1211.19L808.241 1198.48Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.809 1223.91L795.515 1236.64L744.634 1287.54L770.084 1312.97L757.359 1325.7L719.184 1287.54L782.809 1223.91Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 1198.48L1098.61 1287.54L1009.53 1376.6L971.375 1338.42L984.1 1325.7L1009.53 1351.15L1073.16 1287.54L996.825 1211.19L1009.53 1198.48Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.1 1223.91L996.825 1236.64L945.925 1287.54L971.375 1312.97L958.65 1325.7L920.475 1287.54L984.1 1223.91Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 1198.48L1299.9 1287.54L1210.84 1376.6L1172.67 1338.42L1185.39 1325.7L1210.84 1351.15L1274.45 1287.54L1198.12 1211.19L1210.84 1198.48Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 1223.91L1198.12 1236.64L1147.22 1287.54L1172.67 1312.97L1159.94 1325.7L1121.78 1287.54L1185.39 1223.91Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 1198.48L1501.19 1287.54L1412.13 1376.6L1373.96 1338.42L1386.68 1325.7L1412.13 1351.15L1475.74 1287.54L1399.41 1211.19L1412.13 1198.48Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 1223.91L1399.41 1236.64L1348.53 1287.54L1373.96 1312.97L1361.23 1325.7L1323.08 1287.54L1386.68 1223.91Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 1198.48L1702.48 1287.54L1613.42 1376.6L1575.25 1338.42L1587.97 1325.7L1613.42 1351.15L1677.03 1287.54L1600.7 1211.19L1613.42 1198.48Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 1223.91L1600.7 1236.64L1549.82 1287.54L1575.25 1312.97L1562.54 1325.7L1524.37 1287.54L1587.97 1223.91Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 1198.48L1903.77 1287.54L1814.71 1376.6L1776.56 1338.42L1789.26 1325.7L1814.71 1351.15L1878.34 1287.54L1801.99 1211.19L1814.71 1198.48Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 1223.91L1801.99 1236.64L1751.11 1287.54L1776.56 1312.97L1763.83 1325.7L1725.66 1287.54L1789.28 1223.91Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.02 1304.35L194.077 1393.41L105.02 1482.47L66.8455 1444.29L79.5705 1431.57L105.02 1457.02L168.627 1393.41L92.2955 1317.08L105.02 1304.35Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 1329.79L92.2954 1342.51L41.4136 1393.41L66.8454 1418.86L54.1386 1431.57L15.9636 1393.41L79.5704 1329.79Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.312 1304.35L395.368 1393.41L306.312 1482.47L268.155 1444.29L280.862 1431.57L306.312 1457.02L369.918 1393.41L293.587 1317.08L306.312 1304.35Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.862 1329.79L293.587 1342.51L242.705 1393.41L268.155 1418.86L255.43 1431.57L217.255 1393.41L280.862 1329.79Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.603 1304.35L596.66 1393.41L507.603 1482.47L469.446 1444.29L482.171 1431.57L507.603 1457.02L571.228 1393.41L494.878 1317.08L507.603 1304.35Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.171 1329.79L494.896 1342.51L443.996 1393.41L469.446 1418.86L456.721 1431.57L418.546 1393.41L482.171 1329.79Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.913 1304.35L797.969 1393.41L708.913 1482.47L670.738 1444.29L683.463 1431.57L708.894 1457.02L772.519 1393.41L696.188 1317.08L708.913 1304.35Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.463 1329.79L696.188 1342.51L645.288 1393.41L670.738 1418.86L658.013 1431.57L619.856 1393.41L683.463 1329.79Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.204 1304.35L999.261 1393.41L910.204 1482.47L872.029 1444.29L884.754 1431.57L910.204 1457.02L973.811 1393.41L897.479 1317.08L910.204 1304.35Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.754 1329.79L897.479 1342.51L846.579 1393.41L872.029 1418.86L859.304 1431.57L821.147 1393.41L884.754 1329.79Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 1304.35L1200.55 1393.41L1111.5 1482.47L1073.32 1444.29L1086.05 1431.57L1111.5 1457.02L1175.1 1393.41L1098.77 1317.08L1111.5 1304.35Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 1329.79L1098.77 1342.51L1047.89 1393.41L1073.32 1418.86L1060.61 1431.57L1022.44 1393.41L1086.05 1329.79Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 1304.35L1401.84 1393.41L1312.79 1482.47L1274.63 1444.29L1287.34 1431.57L1312.79 1457.02L1376.39 1393.41L1300.06 1317.08L1312.79 1304.35Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 1329.79L1300.06 1342.51L1249.18 1393.41L1274.63 1418.86L1261.9 1431.57L1223.73 1393.41L1287.34 1329.79Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 1304.35L1603.13 1393.41L1514.08 1482.47L1475.92 1444.29L1488.65 1431.57L1514.08 1457.02L1577.7 1393.41L1501.35 1317.08L1514.08 1304.35Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 1329.79L1501.37 1342.51L1450.47 1393.41L1475.92 1418.86L1463.2 1431.57L1425.02 1393.41L1488.65 1329.79Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 1304.35L1804.44 1393.41L1715.39 1482.47L1677.21 1444.29L1689.94 1431.57L1715.39 1457.02L1778.99 1393.41L1702.66 1317.08L1715.39 1304.35Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 1329.79L1702.66 1342.51L1651.76 1393.41L1677.21 1418.86L1664.49 1431.57L1626.33 1393.41L1689.94 1329.79Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 1304.35L2005.74 1393.41L1916.68 1482.47L1878.5 1444.29L1891.23 1431.57L1916.68 1457.02L1980.29 1393.41L1903.95 1317.08L1916.68 1304.35Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 1329.79L1903.95 1342.51L1853.05 1393.41L1878.5 1418.86L1865.78 1431.57L1827.62 1393.41L1891.23 1329.79Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 1411.53L92.1135 1500.59L3.05672 1589.65L-35.1001 1551.47L-22.3751 1538.77L3.05672 1564.2L66.6817 1500.59L-9.6501 1424.26L3.05672 1411.53Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.366 1411.53L293.423 1500.59L204.366 1589.65L166.191 1551.47L178.916 1538.77L204.366 1564.2L267.973 1500.59L191.641 1424.26L204.366 1411.53Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.916 1436.98L191.641 1449.69L140.741 1500.59L166.191 1526.04L153.466 1538.77L115.31 1500.59L178.916 1436.98Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.658 1411.53L494.714 1500.59L405.658 1589.65L367.483 1551.47L380.208 1538.77L405.658 1564.2L469.264 1500.59L392.933 1424.26L405.658 1411.53Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.208 1436.98L392.933 1449.69L342.051 1500.59L367.483 1526.04L354.758 1538.77L316.601 1500.59L380.208 1436.98Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.949 1411.53L696.006 1500.59L606.949 1589.65L568.774 1551.47L581.499 1538.77L606.949 1564.2L670.556 1500.59L594.224 1424.26L606.949 1411.53Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.499 1436.98L594.224 1449.69L543.342 1500.59L568.774 1526.04L556.067 1538.77L517.892 1500.59L581.499 1436.98Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.241 1411.53L897.297 1500.59L808.241 1589.65L770.084 1551.47L782.791 1538.77L808.241 1564.2L871.847 1500.59L795.516 1424.26L808.241 1411.53Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.809 1436.98L795.515 1449.69L744.634 1500.59L770.084 1526.04L757.359 1538.77L719.184 1500.59L782.809 1436.98Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 1411.53L1098.61 1500.59L1009.53 1589.65L971.375 1551.47L984.1 1538.77L1009.53 1564.2L1073.16 1500.59L996.825 1424.26L1009.53 1411.53Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.1 1436.98L996.825 1449.69L945.925 1500.59L971.375 1526.04L958.65 1538.77L920.475 1500.59L984.1 1436.98Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 1411.53L1299.9 1500.59L1210.84 1589.65L1172.67 1551.47L1185.39 1538.77L1210.84 1564.2L1274.45 1500.59L1198.12 1424.26L1210.84 1411.53Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 1436.98L1198.12 1449.69L1147.22 1500.59L1172.67 1526.04L1159.94 1538.77L1121.78 1500.59L1185.39 1436.98Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 1411.53L1501.19 1500.59L1412.13 1589.65L1373.96 1551.47L1386.68 1538.77L1412.13 1564.2L1475.74 1500.59L1399.41 1424.26L1412.13 1411.53Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 1436.98L1399.41 1449.69L1348.53 1500.59L1373.96 1526.04L1361.23 1538.77L1323.08 1500.59L1386.68 1436.98Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 1411.53L1702.48 1500.59L1613.42 1589.65L1575.25 1551.47L1587.97 1538.77L1613.42 1564.2L1677.03 1500.59L1600.7 1424.26L1613.42 1411.53Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 1436.98L1600.7 1449.69L1549.82 1500.59L1575.25 1526.04L1562.54 1538.77L1524.37 1500.59L1587.97 1436.98Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 1411.53L1903.77 1500.59L1814.71 1589.65L1776.56 1551.47L1789.26 1538.77L1814.71 1564.2L1878.34 1500.59L1801.99 1424.26L1814.71 1411.53Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 1436.98L1801.99 1449.69L1751.11 1500.59L1776.56 1526.04L1763.83 1538.77L1725.66 1500.59L1789.28 1436.98Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.02 1517.41L194.077 1606.46L105.02 1695.52L66.8455 1657.36L79.5705 1644.64L105.02 1670.07L168.627 1606.46L92.2955 1530.13L105.02 1517.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 1542.86L92.2954 1555.58L41.4136 1606.46L66.8454 1631.91L54.1386 1644.64L15.9636 1606.46L79.5704 1542.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.312 1517.41L395.368 1606.46L306.312 1695.52L268.155 1657.36L280.862 1644.64L306.312 1670.07L369.918 1606.46L293.587 1530.13L306.312 1517.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.862 1542.86L293.587 1555.58L242.705 1606.46L268.155 1631.91L255.43 1644.64L217.255 1606.46L280.862 1542.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.603 1517.41L596.66 1606.46L507.603 1695.52L469.446 1657.36L482.171 1644.64L507.603 1670.07L571.228 1606.46L494.878 1530.13L507.603 1517.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.171 1542.86L494.896 1555.58L443.996 1606.46L469.446 1631.91L456.721 1644.64L418.546 1606.46L482.171 1542.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.913 1517.41L797.969 1606.46L708.913 1695.52L670.738 1657.36L683.463 1644.64L708.894 1670.07L772.519 1606.46L696.188 1530.13L708.913 1517.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.463 1542.86L696.188 1555.58L645.288 1606.46L670.738 1631.91L658.013 1644.64L619.856 1606.46L683.463 1542.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.204 1517.41L999.261 1606.46L910.204 1695.52L872.029 1657.36L884.754 1644.64L910.204 1670.07L973.811 1606.46L897.479 1530.13L910.204 1517.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.754 1542.86L897.479 1555.58L846.579 1606.46L872.029 1631.91L859.304 1644.64L821.147 1606.46L884.754 1542.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 1517.41L1200.55 1606.46L1111.5 1695.52L1073.32 1657.36L1086.05 1644.64L1111.5 1670.07L1175.1 1606.46L1098.77 1530.13L1111.5 1517.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 1542.86L1098.77 1555.58L1047.89 1606.46L1073.32 1631.91L1060.61 1644.64L1022.44 1606.46L1086.05 1542.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 1517.41L1401.84 1606.46L1312.79 1695.52L1274.63 1657.36L1287.34 1644.64L1312.79 1670.07L1376.39 1606.46L1300.06 1530.13L1312.79 1517.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 1542.86L1300.06 1555.58L1249.18 1606.46L1274.63 1631.91L1261.9 1644.64L1223.73 1606.46L1287.34 1542.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 1517.41L1603.13 1606.46L1514.08 1695.52L1475.92 1657.36L1488.65 1644.64L1514.08 1670.07L1577.7 1606.46L1501.35 1530.13L1514.08 1517.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 1542.86L1501.37 1555.58L1450.47 1606.46L1475.92 1631.91L1463.2 1644.64L1425.02 1606.46L1488.65 1542.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 1517.41L1804.44 1606.46L1715.39 1695.52L1677.21 1657.36L1689.94 1644.64L1715.39 1670.07L1778.99 1606.46L1702.66 1530.13L1715.39 1517.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 1542.86L1702.66 1555.58L1651.76 1606.46L1677.21 1631.91L1664.49 1644.64L1626.33 1606.46L1689.94 1542.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 1517.41L2005.74 1606.46L1916.68 1695.52L1878.5 1657.36L1891.23 1644.64L1916.68 1670.07L1980.29 1606.46L1903.95 1530.13L1916.68 1517.41Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 1542.86L1903.95 1555.58L1853.05 1606.46L1878.5 1631.91L1865.78 1644.64L1827.62 1606.46L1891.23 1542.86Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 1624.59L92.1135 1713.64L3.05672 1802.7L-35.1001 1764.54L-22.3751 1751.82L3.05672 1777.27L66.6817 1713.64L-9.6501 1637.31L3.05672 1624.59Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.366 1624.59L293.423 1713.64L204.366 1802.7L166.191 1764.54L178.916 1751.82L204.366 1777.27L267.973 1713.64L191.641 1637.31L204.366 1624.59Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.916 1650.04L191.641 1662.76L140.741 1713.64L166.191 1739.09L153.466 1751.82L115.31 1713.64L178.916 1650.04Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.658 1624.59L494.714 1713.64L405.658 1802.7L367.483 1764.54L380.208 1751.82L405.658 1777.27L469.264 1713.64L392.933 1637.31L405.658 1624.59Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.208 1650.04L392.933 1662.76L342.051 1713.64L367.483 1739.09L354.758 1751.82L316.601 1713.64L380.208 1650.04Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.949 1624.59L696.006 1713.64L606.949 1802.7L568.774 1764.54L581.499 1751.82L606.949 1777.27L670.556 1713.64L594.224 1637.31L606.949 1624.59Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.499 1650.04L594.224 1662.76L543.342 1713.64L568.774 1739.09L556.067 1751.82L517.892 1713.64L581.499 1650.04Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.241 1624.59L897.297 1713.64L808.241 1802.7L770.084 1764.54L782.791 1751.82L808.241 1777.27L871.847 1713.64L795.516 1637.31L808.241 1624.59Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.809 1650.04L795.515 1662.76L744.634 1713.64L770.084 1739.09L757.359 1751.82L719.184 1713.64L782.809 1650.04Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 1624.59L1098.61 1713.64L1009.53 1802.7L971.375 1764.54L984.1 1751.82L1009.53 1777.27L1073.16 1713.64L996.825 1637.31L1009.53 1624.59Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.1 1650.04L996.825 1662.76L945.925 1713.64L971.375 1739.09L958.65 1751.82L920.475 1713.64L984.1 1650.04Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 1624.59L1299.9 1713.64L1210.84 1802.7L1172.67 1764.54L1185.39 1751.82L1210.84 1777.27L1274.45 1713.64L1198.12 1637.31L1210.84 1624.59Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 1650.04L1198.12 1662.76L1147.22 1713.64L1172.67 1739.09L1159.94 1751.82L1121.78 1713.64L1185.39 1650.04Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 1624.59L1501.19 1713.64L1412.13 1802.7L1373.96 1764.54L1386.68 1751.82L1412.13 1777.27L1475.74 1713.64L1399.41 1637.31L1412.13 1624.59Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 1650.04L1399.41 1662.76L1348.53 1713.64L1373.96 1739.09L1361.23 1751.82L1323.08 1713.64L1386.68 1650.04Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 1624.59L1702.48 1713.64L1613.42 1802.7L1575.25 1764.54L1587.97 1751.82L1613.42 1777.27L1677.03 1713.64L1600.7 1637.31L1613.42 1624.59Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 1650.04L1600.7 1662.76L1549.82 1713.64L1575.25 1739.09L1562.54 1751.82L1524.37 1713.64L1587.97 1650.04Z",
    fill: "#00A44F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 1624.59L1903.77 1713.64L1814.71 1802.7L1776.56 1764.54L1789.26 1751.82L1814.71 1777.27L1878.34 1713.64L1801.99 1637.31L1814.71 1624.59Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 1650.04L1801.99 1662.76L1751.11 1713.64L1776.56 1739.09L1763.83 1751.82L1725.66 1713.64L1789.28 1650.04Z",
    fill: "#00A44F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackGroundOfSectionTwo);
export default __webpack_public_path__ + "static/media/BackGroundOfSectionTwo.62ab0bedde2150214c01f09d7409d33a.svg";
export { ForwardRef as ReactComponent };